import Logo from './Logo'

export default function LoadingScreen() {
  return (
    <div className="h-screen bg-bg-primary flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Logo size={48} className="animate-pulse" />
        <div className="flex gap-1">
          <span className="w-2 h-2 bg-accent rounded-full animate-bounce [animation-delay:0ms]" />
          <span className="w-2 h-2 bg-accent rounded-full animate-bounce [animation-delay:150ms]" />
          <span className="w-2 h-2 bg-accent rounded-full animate-bounce [animation-delay:300ms]" />
        </div>
      </div>
    </div>
  )
}
